<template>
  <div>
    <b-card>
      <div class="d-flex mb-2">
        <div class="mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'concedentes_create' }"
            v-if="$can('concedente:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table striped hover :items="concedentes" :fields="fields" show-empty>
        <template #cell(endereco)="{ item }">
          <CellEndereco
            :endereco="item.endereco"
            :sem_endereco="item.sem_endereco"
          />
        </template>
        <template #cell(contatos)="{ item }">
          <CellContatos v-if="item.contatos" :contatos="item.contatos" />
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('concedente:edit')"
            :view_delete="$can('concedente:delete')"
            edit_to="concedentes_edit"
            @delete="delete_concedente"
          />
        </template>
        <template #cell(select)="{ item }">
          <b-button
            @click="$emit('selected', item)"
            variant="info"
            size="sm"
            class="ml-auto"
            ><font-awesome-icon icon="hand-pointer"
          /></b-button>
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav
        :pagination="pagination"
        @input="loadData()"
        :change_route="false"
      />
    </div>
  </div>
</template>

<script>
import mixins from "@/components/Table/mixins";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [mixins],
  components: {},
  props: {
    actions: {
      type: String,
      default: "default",
    },
  },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
  }),
  computed: {
    ...mapState("concedentes", ["concedentes", "pagination"]),
    fields() {
      let fields = [
        { key: "id", label: "#", class: "col-1" },
        { key: "nome", label: "Nome" },
        { key: "concedente_tipo.nome", label: "Origem", class: "col-2" },
        { key: "endereco", label: "Endereço" },
        { key: "contatos", label: "Formas Contato" },
        {
          key: "concedente_contatos_count",
          label: "Cont",
          class: "col-1",
        },
      ];

      if (this.actions == "default") {
        fields.push({ key: "actions", label: "", class: "cell-actions" });
      }

      if (this.actions == "select") {
        fields.push({ key: "select", label: "", class: "col-1" });
      }

      return fields;
    },
  },
  methods: {
    ...mapActions("concedentes", ["ActionGetAll", "ActionDelete"]),
    /*
    async delete_concedente(concedente) {
      try {
        await this.ActionDelete(concedente.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    searchTerm() {
      this.page = 1;
      this.loadData();
      this.$router.push({
        query: {
          page: this.page,
          q: this.termo_pesquisa,
        },
      });
    },
    async loadData() {
      try {
        await this.ActionGetAll({ page: this.page, q: this.termo_pesquisa });
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    */
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.pagination.cur = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
};
</script>

